const switchers = document.querySelectorAll('.theme-switcher [type="checkbox"]');
const theme = localStorage.getItem('color-theme')

const turnOnDarkTheme = () => {
    document.body.classList.add('theme-dark')
    switchers.forEach(switcher => {
        switcher.checked = true
    })
    localStorage.setItem('color-theme', 'dark')
}
const turnOffDarkTheme = () => {
    document.body.classList.remove('theme-dark')
    switchers.forEach(switcher => {
        switcher.checked = false
    })
    localStorage.setItem('color-theme', 'light')
}

if (theme) {
    theme === 'light' ? turnOffDarkTheme() : turnOnDarkTheme()
} else {
    turnOnDarkTheme()
}

switchers.forEach(switcher => {
    switcher.addEventListener('change', () => {
        if (switcher.checked) {
            turnOnDarkTheme()
        } else {
            turnOffDarkTheme()
        }
    })
});
